module.exports = __webpack_public_path__ + "static/media/frothluxe-2.9a7808a7.jpg";